/**
 * AppConfig — composed from the per-slot modules in this directory.
 */

import type { AppConfig } from '#lib/apps/types.js';
import Logo from '#lib/assets/logos/ableylinks.svg?raw';

import { ELinksCore, EAbleyLinksModule, type ILinksSystemLayers } from './interfaces';
import { modules, LINKS_DATASET } from './layers';
import { filters } from './filters';
import { widgets } from './dashboard';
import { dashboard } from './header';
import { loadSystem, loadSummary } from './loaders';
import { parseLegendLayers } from './legendHelpers';
import { tableTabs, attributesColumns } from './columns';
import AadtLegend from './legends/AadtLegend.svelte';
import type { LegendSection } from '#lib/components/map/legend/types.js';
import { bboxTuple } from '#lib/common/layers.js';

const legendSections: LegendSection[] = [
	{
		label: 'AADT',
		layers: [
			{
				moduleId: EAbleyLinksModule.core,
				layerId: ELinksCore.Aadt,
				label: 'AADT bands (vehicles/day)'
			},
			{ moduleId: EAbleyLinksModule.core, layerId: ELinksCore.Counts, label: 'Count site' }
		]
	}
];

export const linksConfig: AppConfig<ILinksSystemLayers> = {
	id: 'ableylinks',
	name: 'AbleyLinks',
	basePath: '/aadt',
	head: {
		title: 'AbleyLinks',
		description: 'Abley traffic volume AADT data.',
		keywords: 'AADT, traffic volume, ADT, TomTom, Abley Ltd.'
	},
	logo: Logo,
	basemap: 'full',
	version: '0.0.4',
	datasets: [LINKS_DATASET],

	loaders: {
		system: loadSystem,
		summary: loadSummary
	},

	modules,
	legends: [{ moduleId: EAbleyLinksModule.core, component: AadtLegend }],

	parseLegendLayers,
	legendSections,

	map: {
		// Australia-wide — shown before AADT data loads.
		defaultBounds: [112.9, -43.7, 153.7, -10.5],
		getDataBounds: (systemData) => {
			const bbox = systemData?.[EAbleyLinksModule.core]?.[ELinksCore.Aadt]?.bbox;
			return bbox && bboxTuple(bbox);
		}
	},

	table: {
		tabs: tableTabs,
		defaultTabId: 'Aadt',
		filterPlaceholder: 'Filter table by road/region'
	},

	filters,

	dashboard: {
		widgets,
		backgroundImage: '/landing_bg.webp'
	},

	header: {
		dashboard
	},

	attributes: {
		panel: null,
		columns: attributesColumns,
		countermeasures: null
	}
};
